import cn from "classnames";
import React, { useContext, useMemo } from "react";

import { ModalContext } from "../../contexts/ModalContext";
import { OrderItem } from "../../generated/graphql";
import { getPriceWithCurrency } from "../../utils/price";

import ModalHeader from "../ModalHeader";
import ProductDetailGallery from "./ProductDetailGallery";

import styles from "./style.module.scss";

interface ProductDetailModalProps {
  item: OrderItem;
}

const ProductDetailModal: React.FC<ProductDetailModalProps> = props => {
  const { dismissModal } = useContext(ModalContext);
  const { item } = props;

  const hasImage = useMemo(() => {
    return item.images.length > 0;
  }, [item.images.length]);

  const hasDescription = useMemo(() => {
    return item.description && item.description.trim().length > 0;
  }, [item.description]);

  return (
    <div className={styles.mobileModalWrapper}>
      <div className={styles.productDetailModal}>
        <ModalHeader
          title="view.productDetailModal.title"
          isCloseButtonDisabled={false}
          onCloseButtonClicked={dismissModal}
        />
        <div className={styles.productDetailModalContent}>
          <div className={styles.header}>
            <div className={styles.name}>{item.name}</div>
            <div className={styles.price}>
              {getPriceWithCurrency(item.currency, Number(item.unitPrice))}
            </div>
          </div>
          <div className={styles.content}>
            {hasImage && <ProductDetailGallery item={item} />}
            {hasDescription && (
              <div
                className={cn(styles.productInfoWrapper, {
                  [styles.hasImage]: hasImage,
                })}
              >
                <pre className={styles.productInfo}>{item.description}</pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;
